import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { AclHasPermissionDirective } from './acl-has-permission.directive';
import { AclHasFunctionDirective } from './acl-has-function.directive';
import { AclService } from './acl.service';

const COMPONENTS = [AclHasFunctionDirective, AclHasPermissionDirective];

@NgModule({
  imports: [CommonModule],
  declarations: COMPONENTS,
  exports: COMPONENTS,
})
export class ArtstuffAclModule {
  static forRoot(): ModuleWithProviders<ArtstuffAclModule> {
    return {
      ngModule: ArtstuffAclModule,
      providers: [AclService],
    };
  }
}
